<ng-container *ngIf="!!element">
    <div class="slot-container" [class.is-expanded]="isExpanded">
        <div
            #slot1
            class="slot-1 {{ element.settings?.general?.iconPosition }}"
            [ngStyle]="{ 'background-color': this.expandedBackgroundColor, 'color': this.expandedTextColor }"
            (click)="toggleCollapsible()"
        >
            <slot-manager [element]="element.children[0]" [direction]="direction" [resolution]="resolution"></slot-manager>
            <ng-container *ngIf="element.settings?.general?.hasIcon">
                <ng-container *ngTemplateOutlet="icon"></ng-container>
            </ng-container>
        </div>
        <div class="slot-2-init collapsible-content" [ngStyle]="{ height: slotHeight + 'px' }">
            <div class="render-slice-slot-container" #slotContent>
                <slot-manager [element]="element.children[1]" [direction]="direction"></slot-manager>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #icon>
    <div [ngStyle]="{ 'padding-inline': this.iconPadding }">
        <ng-container *ngIf="!isExpanded">
            <svg-icon class="{{ iconColor }}" [src]="element.settings?.general?.expandIconName"></svg-icon>
        </ng-container>
        <ng-container *ngIf="isExpanded">
            <svg-icon class="{{ expandedIconColor }}" [src]="element.settings?.general?.closeIconName"></svg-icon>
        </ng-container>
    </div>
</ng-template>
